<!--
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-19 17:40:09
 * @LastEditors: 牛字杰 niuzijie@.jtexpress
 * @LastEditTime: 2022-08-15 15:44:12
 * @FilePath: \yl-wxcx-coupon-front\src\views\coupon\grabSuccess.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="success-page" :style="{backgroundImage: 'url(' + bannerImg + ')'}">
    <img @click="useConpon" src="@/assets/img/coupon/use.png" alt="领取成功">
  </div>
</template>

<script>
import { receiveBenefit, coupon } from '@/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'GrabSuccess',
  data() {
    return {
      bannerImg: '',
    }
  },
  created() {
    this.getImgList(90)
  },
  methods: {
    async getImgList(type) {
      const params = {
        type,
      }
      const { code, data } = await receiveBenefit.getImgList(params)
      if (code === 1) {
        this.bannerImg = data[0].imageUrl
      }
    },
    /*
    *  appid // 跳转的其他小程序必传appid
    *  path  // 跳转的其他小程序指定的页面地址，需要encodeURIComponent()，不传为首页
    *  envVersion 跳转的其他小程序版本 默认release    develop开发版   trial 体验版  release 正式版
    */
    // 立即使用
    async useConpon() {
      if (this.isWx()) {
        const url = 'pages/sendGoods/index'
        wx.miniProgram.navigateTo({
          url: `/package/pages/transfer/index?appid=wxe37801988179d0a5&path=${encodeURIComponent(url)}`,
          success: async function(res) {
            console.log(res, 'res++++++++++++++++++++++++')
          },
          fail: function(error) {
            console.log(error, 'error++++++++++++++++++++++++++')
          },
        })
      } else {
        const schemeLink = this.getCookie('sendGooodsPage')
        schemeLink ? window.location.href = schemeLink : this.getScheme()
      }
    },
    // 请求小程序链接
    async getScheme() {
      const path = 'pages/sendGoods/index'
      const { code, msg, data } = await coupon.getSchemeUrl(path)
      if (code === 1) {
        // cookie缓存schemeLink， 期限29天
        this.$cookie.set('sendGooodsPage', data, { expires: 29 })
        window.location.href = data // 页面重定向新的地址
      } else {
        alert(msg)
      }
    },
    // 获取cookie
    getCookie(key = 'sendGooodsPage') {
      return this.$cookie.get(key)
    },
    // 判断是否为微信环境
    isWx() {
      // 是否电脑微信或者微信开发者工具企业微信
      return /(micromessenger)/i.test(navigator.userAgent)
    },
  },
}
</script>

<style lang="scss" scoped>
.success-page {
  width: 100%;
  height: 1624rpx;
  // background-image: url('../../assets/img/coupon/received-success.png');
  background-size: 100% 100%;
  padding-top: 510rpx;
  display: flex;
  justify-content: center;
  img {
    width: 360rpx;
    height: 120rpx;
  }
}
</style>
